<template>
<div class="common-navigate">
  <div class="common-logo-panel">
    <div class="common-logo-icon"></div>
    <div class="company-title">{{$t("悠蓝智绘")}}</div>
  </div>
  <div class="navigate-panel">
    <!-- <template v-for="(item,index) in navigateList">
    <div class="navigate-item"  :key="item.value" @click="handlerNavigate(item.value)" :style="styleActiveBind(item.value)">{{item.label}}</div>
    </template> -->
  </div>
  <div class="operate-panel">
    <div class="case-search">
      <label>
        <input class="key-words-search" :placeholder="$t('姓名病例号医院')" v-model="searchParams" @click="handlerNavigateToCaseList"></input>
      </label>
    </div>
<!--    <img :src="/static/images/common/ico_user_face_normal.png" alt="" />-->
    <div class="user-icon">
      <img crossorigin="anonymous" :src="$store.state.userInfo.userIcon ? $store.state.userInfo.userIcon.replace('http://','https://') : '/static/images/common/ico_user_face_normal.png'" alt="" />
    </div>
    <div class="asdf">
      <Dropdown trigger="click"  @on-click="handleChange" class="choice" transfer-class-name="diyClass">
        <a href="javascript:void(0)">
          <Icon type="arrow-down-b"></Icon>
        </a>
        <DropdownMenu slot="list">
          <DropdownItem name="message">
            <span>{{$t("个人中心")}}</span>
          </DropdownItem>
          <DropdownItem name="cancel" class="cancel">{{$t("退出登陆")}}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <Select v-model="currentLan" class="lan-change">
      <Option v-for="item in languageList" :value="item.value" :key="item.value">{{ item.label }}</Option>
    </Select>
  </div>
</div>
</template>

<script>
import cookie from "../../../static/js/cookie";
import exitConfirm from "../../../static/js/confirm"

export default {
  name: "commonNavigate",
  data(){
    return{
      searchParams:'',
      navigateList:[
        {
          label:this.$t('工作站'),
          value:'home',
        },
        // {
        //   label:'悠蓝学院',
        //   value:'college',
        // },
        // {
        //   label:'关于我们',
        //   value:'about',
        // },
      ],
      currentLan:this.$i18n.locale,
      languageList:[
        {
          value:'zh',
          label:"中文"
        },
        {
          value:'en',
          label:'EN'
        }, 
      ],
    }
  },
  model:{
    prop:'navigateTo',
    event:'navigate'
  },
  props:{
    navigateTo:String,

  },
  watch:{
    searchParams:{
      immediate:true,
      handler:function (params,oldParams){
        if(params!==oldParams){
          this.$store.commit('searchParams',params);
        }

      }
    },
    currentLan:function (){
      this.$i18n.locale = this.currentLan ;
      cookie.set('language', this.currentLan);
      window.location.reload();
    },
  },
  computed: {
    navigateBind:{
      get(){
        return this.navigateTo;
      },
      set(value){
        this.$emit('navigate',value)
      }
    },

  },
  methods:{
    handlerNavigateToCaseList:function (){
      this.$emit('navigateToHome','myCases')

    },
    // handleOnSearch:function (){
    //   this.$store.commit('searchParams',this.searchParams);
    // },
    handlerNavigate:function (param){
      this.navigateBind=param;
    },
    styleActiveBind:function (param){
      if(this.navigateBind===param){
        return{
          'background-color':'rgba(255, 255, 255, 0.17)',
          'border-radius': '4px',
          'font-weight':500,
        }
      }

    },
    handleChange(name) {
      let This = this;
      if (name == 'message') {
        // this.$router.push({path: '/userMessage'})
        this.$router.push({path:'/home',query:{navigateTo:'userCenter'}})
      } else{
        exitConfirm({
          title: this.$t('退出登陆'),
          content: this.$t('确定要退出登陆'),
          okText: this.$t('确定'),
          cancelText: this.$t('取消'),
          onOk: () => {
            This.$router.push('logout');
          },
        },'exit-modal')

      }
    },
  }
}
</script>
<style>
.lan-change .ivu-select {
  background-color: transparent !important;
  border: none;
  outline: none;
}
.lan-change .ivu-select-selection {
  background-color: transparent !important;
  border: none;
  outline: none;
}
.lan-change .ivu-select-dropdown,
.lan-change .ivu-select-dropdown-list {
  border-radius: 8px !important;
  background-color: #192229;
  color: #ffffff !important;
  overflow: hidden;
  font-size: 16px;
  font-weight: 400;
}
.lan-change .ivu-select-item {
  color: #ffffff;
  background-color: #192229 !important;
}
.lan-change .ivu-select-item-selected,
.lan-change .ivu-select-item-focus {
  background-color: #192229 !important;
  color: #ffffff !important;
}

.asdf .ivu-dropdown {
  position: absolute;
  font-size: 70px;
  left: -2px;
  margin: 0;
  top: 0px;
  width: 50px;
  height: 50px;
  /*background: #c61c1c;*/
}

.asdf .ivu-dropdown-rel {
  width: 50px;
  height: 50px;
  z-index: 9999999;
}
.asdf .choice .ivu-icon-arrow-down-b {
  color: transparent;
}
.asdf .choice .ivu-select-dropdown {
  padding-top: 10px;
  padding-bottom: 10px;
  z-index: 99999;
  width: 100px;
  border-radius: 12px;
}
.asdf .ivu-select-dropdown {
  width: auto !important;
}
</style > <style scoped > .common-navigate {
  height: 60px;
  width: 100%;
  min-width: 1440px;
  background: #34556c;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-right: 2%;
}
.common-logo-panel {
  width: 30%;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding-left: 20px;
}
.common-logo-icon {
  width: 32px;
  height: 32px;
  background-image: url("/static/images/login/ico_uAlign_logo_small_1.png");
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 12px;
}
.company-title {
  font-size: 26px;
  color: #f0f0f0;
  letter-spacing: 2px;
}
.navigate-panel {
  width: 30%;
  height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.operate-panel {
  width: 30%;
  height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 12px 20px;
}
.navigate-item {
  padding: 8px 20px;
  height: 36px;
  margin-right: 8px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
}
.case-search {
  width: 200px;
  height: 36px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.17);
  padding: 4px 36px 4px 6px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  margin-right: 28px;
}
.case-search::after {
  content: "";
  background-image: url("/static/images/common/ico_case_search.png");
  background-size: contain;
  background-repeat: no-repeat;
  width: 20px;
  height: 20px;
  position: absolute;
  top: 9px;
  right: 6px;
}
.key-words-search {
  height: 20px;
  background-color: transparent;
  border: none;
  outline: none;
  color: rgba(255, 255, 255, 0.37);
  font-size: 14px;
  font-weight: 400;
}
.user-icon {
  width: 36px;
  height: 36px;
  border-radius: 36px;
  background-color: transparent;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  margin-right: 28px;
}
.user-icon img {
  width: 36px;
  height: 36px;
}
.lan-change {
  margin-right: 20px;
  font-size: 16px;
  color: #ffffff;
  font-weight: 400;
  width: 72px;
}
.asdf {
  position: relative;
  display: inline-block;
  left: -58px;
  top: -18px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/commonNavigate.vue